$(".custom-collection-slider").slick({
  dots: false,
  infinite: true,
  speed: 300,
  centerMode: true,
  speed: 300,
  centerPadding: "50px",
  slidesToShow: 3,
  slidesToScroll: 1,
  arrows: true,
  prevArrow:
    '<button class="slide-arrow prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="32" height="28" viewBox="0 0 32 28" fill="none"><path d="M29.36 12.3272H6.61L14.89 3.86555C15.53 3.20542 15.53 2.14522 14.89 1.4951C14.25 0.834968 13.21 0.834968 12.57 1.4951L1.48 12.8173C0.84 13.4774 0.84 14.5376 1.48 15.1877L12.57 26.5099C12.89 26.84 13.31 27 13.73 27C14.15 27 14.57 26.84 14.89 26.5099C15.53 25.8498 15.53 24.7896 14.89 24.1395L6.61 15.6878H29.36C30.27 15.6878 31 14.9377 31 14.0075C31 13.0773 30.26 12.3272 29.36 12.3272Z" fill="#004D4A"/></svg></button>',
  nextArrow:
    '<button class="slide-arrow next-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="32" height="28" viewBox="0 0 32 28" fill="none"><path d="M2.64 12.3272H25.39L17.11 3.86555C16.47 3.20542 16.47 2.14522 17.11 1.4951C17.75 0.834968 18.79 0.834968 19.43 1.4951L30.52 12.8173C31.16 13.4774 31.16 14.5376 30.52 15.1877L19.43 26.5099C19.11 26.84 18.69 27 18.27 27C17.85 27 17.43 26.84 17.11 26.5099C16.47 25.8498 16.47 24.7896 17.11 24.1395L25.39 15.6878H2.64C1.73 15.6878 1 14.9377 1 14.0075C1 13.0773 1.74 12.3272 2.64 12.3272Z" fill="#004D4A"/></svg></button>',
  responsive: [
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 576,
      settings: {
        slidesToShow: 1, // Ensure only 1 slide is shown
        slidesToScroll: 1, // Ensure only 1 slide is scrolled
        centerPadding: "30px",
      },
    },
  ],
});

$(document).ready(function () {
  var $variant = $('.product-index [data-block-type="variant-picker"]');
  var $quantity = $('.product-index [data-block-type="quantity-selector"]');

  // Check if both elements exist
  if ($variant.length && $quantity.length) {
    // Wrap them in a new div
    $variant
      .add($quantity)
      .wrapAll('<div class="product-info__block-wrapper"></div>');
  }
});


// $(document).ready(function () {
//   var $country = $('#filter-panel .accordion-list .filter-country');
//   var $region = $('#filter-panel .accordion-list .filter-region');

//   // Check if both elements exist
//   if ($country.length && $region.length) {
//     // Create the wrapper structure
//     $country
//       .add($region)
//       .wrapAll('<div class="accordion group double-filter" is="accordion-disclosure" aria-expanded="false"></div>');
    
//     // Add heading before the filters
//     $('.double-filter').prepend('<summary class="filter-heading"><span class="accordion__toggle h6"><span class="text-with-icon">Country / Region / Appelation<svg class="group-expanded:rotate icon" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M13.707 3.29314C14.0731 3.65925 14.0957 4.23825 13.7754 4.63103L13.707 4.7072L7.70702 10.7072C7.3165 11.0977 6.68348 11.0977 6.29296 10.7072L0.292959 4.7072C-0.0975647 4.31668 -0.0975647 3.68366 0.292959 3.29314C0.683483 2.90261 1.3165 2.90261 1.70702 3.29314L6.99999 8.58611L12.293 3.29314L12.3691 3.22478C12.7619 2.90443 13.3409 2.92702 13.707 3.29314Z" fill="#004D4A"></path></svg></span></span></summary>');
    
//     // Wrap filters in sub-filter div
//     $country
//       .add($region)
//       .wrapAll('<div class="sub-filter accordion__content"></div>');
//   }
// });


$(document).ready(function () {
  var $variant = $('.pdp-page-product [data-block-type="variant-picker"]');
  var $quantity = $('.pdp-page-product [data-block-type="quantity-selector"]');
  var $buybuttons = $('.pdp-page-product [data-block-type="buy-buttons"]');

  // Create wrapper div
  var $wrapper = $('<div class="custom-wrap"></div>');

  // Insert the wrapper before the first element
  $variant.first().before($wrapper);

  // Append all elements to the wrapper
  $wrapper.append($quantity, $buybuttons, $variant);
});

$(document).ready(function() {
  document.addEventListener('variant:change', function(event) {
    if (event.detail && event.detail.variant) {
      const variantId = event.detail.variant.id;
      // Support both main product page (.shopify-product-form) and product cards (product-form)
      const productForm = event.target.closest('.shopify-product-form, product-form, .product-card');

      if (!productForm) return;

      const inventoryElements = productForm.querySelectorAll('[data-variant-id]');
      
      inventoryElements.forEach(function(element) {
        const elementVariantId = parseInt(element.getAttribute('data-variant-id'));
        const isCurrentVariant = elementVariantId === variantId;
        
        if (isCurrentVariant) {
          element.removeAttribute('hidden');
          
          const inventoryContainer = element.closest('.inventory, variant-inventory');
          const urgency = element.getAttribute('data-inventory-urgency');
          
          if (inventoryContainer && urgency) {
            inventoryContainer.className = inventoryContainer.className
              .replace(/text-(success|warning|error)/g, '')
              .trim();
            
            const statusClass =
              urgency === 'green' ? 'comfortable-stock' :
              urgency === 'orange' ? 'limited-stock' : 'urgent-stock';
              
            inventoryContainer.classList.add('inventory', statusClass);
          }
        } else {
          element.setAttribute('hidden', '');
        }
      });
    }
  });
});


$(".tab-menu li a").on("click", function () {
  var target = $(this).attr("data-rel");

  $(".tab-menu li a").removeClass("active");
  $(this).addClass("active");

  $("#" + target)
    .fadeIn("slow")
    .siblings(".tab-box")
    .hide();

  // 💡 If it's the Ratings tab, wait then init or reset Slick
  if (target === "tab-3") {
    setTimeout(function () {
      const $slider = $(".wine-review-section.rating-slider");

      if (!$slider.hasClass("slick-initialized")) {
        $slider.slick({
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: true,
          dots: false,
          infinite: false,
          prevArrow:
            '<button class="slide-arrow prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="32" height="28" viewBox="0 0 32 28" fill="none"><path d="M29.36 12.3272H6.61L14.89 3.86555C15.53 3.20542 15.53 2.14522 14.89 1.4951C14.25 0.834968 13.21 0.834968 12.57 1.4951L1.48 12.8173C0.84 13.4774 0.84 14.5376 1.48 15.1877L12.57 26.5099C12.89 26.84 13.31 27 13.73 27C14.15 27 14.57 26.84 14.89 26.5099C15.53 25.8498 15.53 24.7896 14.89 24.1395L6.61 15.6878H29.36C30.27 15.6878 31 14.9377 31 14.0075C31 13.0773 30.26 12.3272 29.36 12.3272Z" fill="#004D4A"/></svg></button>',
          nextArrow:
            '<button class="slide-arrow next-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="32" height="28" viewBox="0 0 32 28" fill="none"><path d="M2.64 12.3272H25.39L17.11 3.86555C16.47 3.20542 16.47 2.14522 17.11 1.4951C17.75 0.834968 18.79 0.834968 19.43 1.4951L30.52 12.8173C31.16 13.4774 31.16 14.5376 30.52 15.1877L19.43 26.5099C19.11 26.84 18.69 27 18.27 27C17.85 27 17.43 26.84 17.11 26.5099C16.47 25.8498 16.47 24.7896 17.11 24.1395L25.39 15.6878H2.64C1.73 15.6878 1 14.9377 1 14.0075C1 13.0773 1.74 12.3272 2.64 12.3272Z" fill="#004D4A"/></svg></button>',
          responsive: [
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1,
              },
            },
            {
              breakpoint: 576,
              settings: "unslick", // ✅ destroys slick below 576px
            },
          ],
        });
      } else {
        $slider.slick("setPosition");
      }
    }, 300); // wait for fadeIn
  }

  return false;
});
// product title diff
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".product-title").forEach(function(el) {
    el.innerHTML = el.textContent.replace(/(\d+)/g, "<span class='highlight-digit'>$1</span>");
  });
});
// Add CLass on toggle click
  document.addEventListener("DOMContentLoaded", function () {
    const btn = document.querySelector("#toggleFilterBtn");
    const productList = document.querySelector(".product-list");

    if (btn && productList) {
      btn.addEventListener("click", function () {
        productList.classList.toggle("filters-open");
      });
    }
  });

// 16-08-2025 Start

  $('body').on('change', '.switch-new', function () {
    const $checkbox = $(this);
    const $label = $checkbox.closest('.toggle-switch-text');
    
    // --- FIX ---
    // This selector now finds the next sibling div, whether it has the class
    // '.sub_toggle_list' (for states) or '.sub_inner_toggle_list' (for cities).
    const $subList = $label.next('.sub_toggle_list, .sub_inner_toggle_list');

    if ($checkbox.is(':checked')) {
      $label.addClass('active');
      $subList.slideDown().addClass('active');
    } else {
      $label.removeClass('active');
      $subList.slideUp().removeClass('active');
    }
  });

  $('body').on('click', '[data-show-all]', function () {
    $(this).siblings('.checkbox-control:hidden').show(); 
    $(this).hide();
  });

 $('body').on('click', '[data-show-other]', function() {
    $(this).siblings('.fillter_main_toggle:hidden').show();
    $(this).hide();
  });

  $('body').on('click', '#show_all_states', function() {
    $(this).closest('.sub_toggle_list').find('.state-and-city-group:hidden').show();
    $(this).hide();
  });

  $('body').on('click', 'button[id^="show_all_cities"]', function() {
    $(this).closest('.sub_inner_toggle_list').find('label.toggle-switch-text:hidden').show();
    $(this).hide();
  });
// 16-08-2025 End